// extracted by mini-css-extract-plugin
export default {"modal-bg":"CartModal_modal-bg__0T7yN","showBg":"CartModal_showBg__49Dcw","cart-modal":"CartModal_cart-modal__ehJBx","showModal":"CartModal_showModal__82ERh"};